import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerTooltipColor } from '../../palette';
import { ControllerFont } from '../../fonts';

const theme = createTheme();
const TOOLTIP_GAP = `${theme.spacing(2)} !important`;

export const TooltipComponent: Components = {
  MuiTooltip: {
    styleOverrides: {
      arrow: {
        color: String(ControllerTooltipColor.DefaultBg),
      },
      tooltip: {
        backgroundColor: String(ControllerTooltipColor.DefaultBg),
        borderRadius: theme.spacing(0.25),
        color: String(ControllerTooltipColor.DefaultFg),
        ...ControllerFont.Body400R,
      },
      tooltipPlacementBottom: {
        marginTop: TOOLTIP_GAP,
      },
      tooltipPlacementLeft: {
        marginRight: TOOLTIP_GAP,
      },
      tooltipPlacementRight: {
        marginLeft: TOOLTIP_GAP,
      },
      tooltipPlacementTop: {
        marginBottom: TOOLTIP_GAP,
      },
    },
  },
};
